<template>
  <div>
    <app-header />
    <mpn-page-title :title="pageTitle" />

    <!-- S : main -->
    <main class="a-service-main">
      <!-- S : 컨텐츠 영역 -->
      <div
        id="main_content"
        class="a-service-container"
      >
      <!-- !!!! contents here -->
      <!-- contents here !!!! -->
      </div>
      <!-- E : 컨텐츠 영역 -->
    </main>
    <!-- E : main -->

    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'name me',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      pageTitle: 'title me',
    };
  },
};
</script>
